import { useKeenSlider } from "keen-slider/react";
import { Link } from "react-router-dom";

import "keen-slider/keen-slider.min.css";
import "./GuestLanding.css";

import { signInWithGoogle, signInWithFacebook } from "../firebase"; // ← 加入這行

const features = [
  {
    img: "/images/MainLobby.png",
    title: "Main Lobby",
    desc: "A vibrant starting point. Kids see all their courses, chat with friends, and explore together."
  },
  {
    img: "/images/StudentDashboard.png",
    title: "Student Dashboard",
    desc: "A personal hub for each child—track growth, set goals, and care for their own learning pet!"
  },
  {
    img: "/images/MathPractice.png",
    title: "Math Practice",
    desc: "Intuitive math challenges. Build skills and confidence step-by-step, with instant feedback."
  },
  {
    img: "/images/SpellingPractice.png",
    title: "Spelling Practice",
    desc: "Engaging games make words and spelling fun. Kids love to compete and improve."
  },
  {
    img: "/images/ListeningPractice.png",
    title: "Listening Practice",
    desc: "Interactive stories and activities to sharpen listening and comprehension."
  },
  {
    img: "/images/ScienceJeopardy.png",
    title: "Science Jeopardy",
    desc: "Science comes alive in friendly competitions—curiosity meets teamwork!"
  }
];

export default function GuestLanding() {
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    mode: "snap",
    slides: { perView: 1, spacing: 24, origin: "center" },
    breakpoints: {
      "(min-width: 1100px)": {
        slides: { perView: 2.5, spacing: 32, origin: "center" }
      },
      "(min-width: 700px)": {
        slides: { perView: 2, spacing: 28, origin: "center" }
      }
    }
  });

  const next = () => instanceRef.current && instanceRef.current.next();
  const prev = () => instanceRef.current && instanceRef.current.prev();

  return (
    <div className="guest-landing-bg">
      {/* --- TOP BANNER --- */}
      <div className="guest-landing-topbar">
        <img src="/images/KoalaQuestLogoSmall.png" alt="Koala Quest Logo" className="guest-landing-topbar-logo" />
        <div>
          <div className="guest-landing-topbar-title">KOALA QUEST</div>
          <div className="guest-landing-topbar-tagline">Learn. Play. Succeed.</div>
        </div>
      </div>

      {/* --- AUTH BUTTONS FOR MOBILE --- */}
      <div className="guest-mobile-auth-bar">
        <Link to="/login">Log In</Link>
        <Link to="/signup">Sign Up</Link>
        <button onClick={signInWithGoogle} className="guest-social-login google">Google 登入</button>
        <button onClick={signInWithFacebook} className="guest-social-login facebook">Facebook 登入</button>
      </div>

      {/* --- HERO SECTION --- */}
      <section className="guest-landing-features-main">
        <h2 className="guest-landing-features-title">See What Awaits Your Child</h2>
        <div className="guest-landing-slider-frame">
          <button className="guest-landing-slider-arrow left" onClick={prev}>&lt;</button>
          <div ref={sliderRef} className="keen-slider guest-landing-slider">
            {features.map((feat, idx) => (
              <div className="keen-slider__slide guest-landing-slide-modern" key={idx}>
                <div className="guest-landing-slide-card-modern">
                  <img src={feat.img} alt={feat.title} />
                  <div className="guest-landing-slide-title">{feat.title}</div>
                  <div className="guest-landing-slide-desc">{feat.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <button className="guest-landing-slider-arrow right" onClick={next}>&gt;</button>
        </div>
      </section>
    </div>
  );
}
